import React from "react"
import { Link } from "gatsby"

import "./nav.css"

export const Nav = () => {
  return (
    <div className="navigation">
      <ul>
        <Link to="/">Ich</Link>
        <Link to="/blog">Blog</Link>
        <Link to="/contact">Kontakt</Link>
      </ul>
    </div>
  )
}

export default Nav
